module.exports = __webpack_public_path__ + "static/FUN-f6c3d63c7f3f1519fffe6703ab36f896.svg";